import { CircularProgress } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_LANDING_PAGE } from "../../Routes/RouteMapping";
import { GENERIC_SCREEN_CONTENT } from "../../utils/constants";
import { launchSDK } from "../../utils/helpers";
import Icons from "../Icons/icons";
import {
  InvertedPrimaryButton,
  PrimaryButton,
  FullScreenLoader,
} from "../index";
import "./GenericMessage.scss";
function GenericMessage({SetLoader}) {
  
  const navigate = useNavigate();

  
  return (
    <Box className="message-container">
      <Box>
        <Box className="header">{GENERIC_SCREEN_CONTENT.header}</Box>
        {GENERIC_SCREEN_CONTENT?.permissions?.map((permission, index) => (
          <Box className="permissions-container" key={index}>
            { window.innerWidth < 630 ? permission.mobile_icon  : permission.icon}
            <h2 className="message-title">{permission.title}</h2>
            <p className="message-point">{permission.message}</p>
          </Box>
        ))}
      </Box>
      <Box className="button-group">
        <PrimaryButton
          onClick={() => launchSDK(SetLoader, navigate)}
          htmlType="submit"
          label="Proceed"
        />
      </Box>
    </Box>
  );
}

export default GenericMessage;
